import React, { PureComponent } from "react";
import { Row, Col, Card, CardBody, CardHeader } from "reactstrap";
import moment from "moment";

import transactions from "@/api/transactions";
import accounts from "@/api/accounts";
import reports from "@/api/reports";

import TransactionsTable from "../Components/TransactionsTable";
import TableContainer from "../Components/TableContainer";
import LoadingOverlay from "../Components/LoadingOverlay";
import CurrencyCard from "../Components/CurrencyCard";
import { handleError } from "@/util/errorHandler";
import { APP_CONST } from "@/store/dataStore";

class Dashboard extends PureComponent {
  state = {
    isSummaryLoading: true,
    totalAccount: 0,
    totalAmountKhr: 0,
    totalAmountUsd: 0,
    accountDomain: "-",
  };

  inComingtable = React.createRef();
  outGoingtable = React.createRef();

  handleIncomingNavigate = page => {
    setImmediate(() => {
      this.inComingtable.current.handlePageChange(page + 1);
    });
  };

  handleOutgoingNavigate = page => {
    setImmediate(() => {
      this.outGoingtable.current.handlePageChange(page + 1);
    });
  };

  componentDidMount() {
    this.loadAccountsSummary();
  }

  loadAccountsSummary = async () => {
    try {
      this.setState({ isSummaryLoading: true });

      const data = await accounts.getAllAccountsSummary();

      this.setState({
        totalAccount: data.totalAccount,
        totalAmountKhr: data.totalAmounts["khr#nbc"],
        totalAmountUsd: data.totalAmounts["usd#nbc"],
        accountDomain: data.accountDomain,
      });
    } catch (err) {
      handleError(err);
    } finally {
      this.setState({ isSummaryLoading: false });
    }
  };

  loadIncomingTransactions = transactions.searchAdapter({
    direction: "INCOMING",
    directionSubject: "incoming/today",
    isToday: true,
  });
  loadOutgoingTransactions = transactions.searchAdapter({
    direction: "OUTGOING",
    directionSubject: "outgoing/today",
    isToday: true,
  });

  render() {
    return (
      <div className="animated fadeIn">
        <Row style={{ marginBottom: 20 }}>
          <LoadingOverlay loading={this.state.isSummaryLoading} />
          <Col xl="6" lg="12" sm="12" md="12">
            <h3>Total balance</h3>
            <Row>
              <Col xl="6" lg="12" sm="12" md="12">
                <Card>
                  <CardBody style={{ padding: 10 }}>
                    <CurrencyCard
                      title="Riel account"
                      currency="riel"
                      balance={this.state.totalAmountKhr}
                      data-cy="riel"
                    />
                  </CardBody>
                </Card>
              </Col>
              <Col xl="6" lg="12" sm="12" md="12">
                <Card>
                  <CardBody style={{ padding: 10 }}>
                    <CurrencyCard
                      title="Dollar account"
                      currency="usd"
                      balance={this.state.totalAmountUsd}
                      data-cy="dollar"
                    />
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Col>
        </Row>
        <h3 data-cy="total">
          Total number of accounts: {this.state.totalAccount}
        </h3>
        <Row>
          <Col xl="6" lg="12" sm="12" md="12">
            <Card data-cy="incoming" style={{ marginBottom: 20 }}>
              <CardHeader>Incoming Transactions</CardHeader>
              <CardBody>
                <TableContainer
                  autoLoad={true}
                  ref={this.inComingtable}
                  loadData={this.loadIncomingTransactions}
                  requestReport={reports.requestIncomingTransactions}
                  reportWithoutDateRange={false}
                  reportWithInitialDates={{
                    dateFrom: moment().subtract(
                      APP_CONST.REPORT_BACK_DAYS(),
                      "days",
                    ),
                    dateTo: moment(),
                  }}
                  isTransaction={true}>
                  <TransactionsTable
                    type="incoming"
                    businessStatusFilter
                    statusFilter
                    onNavigate={this.handleIncomingNavigate}
                  />
                </TableContainer>
              </CardBody>
            </Card>
          </Col>
          <Col xl="6" lg="12" sm="12" md="12">
            <Card data-cy="outgoing" style={{ marginBottom: 20 }}>
              <CardHeader>Outgoing Transactions</CardHeader>
              <CardBody>
                <TableContainer
                  autoLoad={true}
                  ref={this.outGoingtable}
                  loadData={this.loadOutgoingTransactions}
                  requestReport={reports.requestOutgoingTransactions}
                  reportWithoutDateRange={false}
                  reportWithInitialDates={{
                    dateFrom: moment().subtract(
                      APP_CONST.REPORT_BACK_DAYS(),
                      "days",
                    ),
                    dateTo: moment(),
                  }}
                  isTransaction={true}>
                  <TransactionsTable
                    type="outgoing"
                    businessStatusFilter
                    statusFilter
                    onNavigate={this.handleOutgoingNavigate}
                  />
                </TableContainer>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

export default Dashboard;
